import React from 'react'
import { useTheme } from 'styled-components'
import { Container, Flex, Grid } from '../../styleguide/layout'
import { H3, P } from '../../styleguide/typography'

// images
import crypto from "../../../assets/crypto.png"
import secured from "../../../assets/secured.png"

const Features = () => {

  const theme = useTheme();

  return (
    <Container padding="6rem 6%">
      <Grid tempCol="repeat(2, 1fr)" mobileTempCol="100%" gap="2rem">
        <Flex 
          width="100%" 
          bg={ theme.colors.lighterGray } 
          minh="625px"
          padding="7rem 2.5rem"
          borderRadius="1rem"
          gap="2rem"
          direction="column"
          items="center"
          minHMobile="300px"
          paddingMobile="3rem 1.5rem"
        >
          <img 
            src={crypto} 
            style={{ width: "100%", maxWidth: "300px", height: "auto" }} 
            alt="crypto"   
          />

          <H3 align="center" textTransform="upper">Support for popular blockchains.</H3>

          <P align="center">
            Mula wallet makes it easy for users to buy, hold and transact 
            on the bitcoin blockchain, Ethereum blockchain and Binance 
            Smart Chain. 
            Many  more blockchains will be added soon.
          </P>
        </Flex>
        <Flex 
          width="100%" 
          bg={ theme.colors.lighterGray } 
          minh="500px"
          padding="7rem 2.5rem"
          borderRadius="1rem"
          gap="2rem"
          direction="column"
          items="center"
          minHMobile="300px"
          paddingMobile="3rem 1.5rem"
        >
          <img 
            src={secured} 
            style={{ width: "100%", maxWidth: "300px", height: "auto" }} 
            alt="secured"   
          />

          <H3 align="center" textTransform="upper">YOUR FUNDS IS YOUR FUNDS</H3>

          <P align="center">
            Mula wallet is completely Non-custodial. Your private keys are 
            completely encrypted and securely stored locally on your 
            mobile phone.
            Secured with passcode generation and biometric security.
          </P>
        </Flex>
      </Grid>
    </Container>
  )
}

export default Features